import { getIp } from "../services/IpifyService";
import { ReactNode, createContext, useEffect, useState } from "react";

interface IpifyProviderProps {
    children: ReactNode;
}

interface IpifyType {
    ip: string | undefined
}

export function IpifyProvider({ children }: IpifyProviderProps) {

    const [ ip, setIp ] = useState<string | undefined>();

    useEffect(() => {
        getIp().then(ip => setIp(ip));
    }, []);

    return (
        <IpifyContext.Provider value={{ ip }}>
            {children}
        </IpifyContext.Provider>
    )
}

export const IpifyContext = createContext<IpifyType | undefined>(undefined);